import { h, Component } from "preact";
import { connect } from "react-redux";

import Page from "../../components/Page";
import Content from "../../components/Content";

import { pass } from "../../state/actions/waitlistActions";
import successIcon from "../../assets/images/icon-success.svg";

class WaitlistPass extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { pass, waitlistId } = this.props;
    pass(waitlistId);
  }

  render() {
    const { waitlist } = this.props;
    if (waitlist.pass.loading) {
      return (
        <Page>
          <Content style={{ padding: 30 }}>
            <div class="loading loading-lg" />
          </Content>
        </Page>
      );
    }

    const successStyle = {
      background: `url(${successIcon}) no-repeat center`,
      backgroundSize: 160,
      color: "#1bab74",
      margin: "0px 12px",
      padding: "180px 0 4px 28px",
      textAlign: "center"
    };

    return (
      <Page>
        <Content style={{ padding: 30 }}>
          <div style={successStyle}>
            <span>You have been removed from the waitlist</span>
          </div>
        </Content>
      </Page>
    );
  }
}
export default connect(
  (state, ownProps) => ({ waitlist: state.waitlist }),
  {
    pass
  }
)(WaitlistPass);



// WEBPACK FOOTER //
// ./routes/waitlistPass/WaitlistPass.js